import {KAYTEK_LOCAL_SERVICE_BASE_URL} from '../../Helpers/localServiceUrl'


export const PREDICT = 'PREDICT'
export const RECEIVE_TEXT_STREAM = 'RECEIVE_TEXT_STREAM'
export const RECEIVE_TEXT_STREAM_REFLECTED = 'RECEIVE_TEXT_STREAM_REFLECTED'
export const STARTING_COMPLETION = 'STARTING_COMPLETION'
export const SET_ANIMATION = 'SET_ANIMATION'
export const SET_END_OF_STREAM = 'SET_END_OF_STREAM'
export const SET_END_OF_STREAM_REFLECTED = 'SET_END_OF_STREAM_REFLECTED'
export const GET_GENERAL_META_DATA = 'GET_GENERAL_META_DATA'
export const GET_GENERAL_META_DATA_RESULT = 'GET_GENERAL_META_DATA_RESULT'
export const ON_APP_LOAD = 'ON_APP_LOAD'
export const SCROLL_TEXT = 'SCROLL_TEXT'
export const PLAY_KEYSTROKE = 'PLAY_KEYSTROKE'
export const TIME_TO_INIT_THEME_AFTER_KEYSTROKE = 20*60*1000 // 20 minutes
export const TERMINATE = 'TERMINATE'
export const SET_PLACEHOLDER_MESSAGE = 'SET_PLACEHOLDER_MESSAGE'
export const TURN_PLACEHOLDER_MESSAGE = 'TURN_PLACEHOLDER_MESSAGE'
export const GET_NEW_SESSION_ID = 'GET_NEW_SESSION_ID'
export const NEW_SESSION_ID_SUCCESS = 'NEW_SESSION_ID_SUCCESS'
export const SET_SHOULD_FOCUS_SEND_BUTTON = 'SET_SHOULD_FOCUS_SEND_BUTTON'
export const SET_SHOULD_FOCUS_INPUT_FIELD = 'SET_SHOULD_FOCUS_INPUT_FIELD'
export const SET_NETWORK_SPEED = 'SET_NETWORK_SPEED'
export const TOPN_BROWSING_DELAY = 350
export const SPEED_MODULATION_DELAY = 0
export const MINIMAL_DEBUG_DELAY = 0
export const TOPN_AFTER_SELECTION_DELAY = 500
export const TIME_TO_WAIT_FOR_NEW_SESSION_ID = 15_000
export const NETWORK_SPEED = 'NETWORK_SPEED'
export const UPLOAD_MBPS = 'uploadMbps'
export const DOWNLOAD_MBPS = 'downloadMbps'
export const PLACE_HOLDER_MESSAGE = 'PLACE_HOLDER_MESSAGE'
export const SHOULD_FOCUS_SEND_BUTTON = 'SHOULD_FOCUS_SEND_BUTTON'
export const SHOULD_FOCUS_INPUT_FIELD = 'SHOULD_FOCUS_INPUT_FIELD'
export const CHAT = 'chat'
export const REFLECTED_CHAT = 'reflectedChat'
export const ANIMATION = 'animation'
export const GENERAL_META_DATA = 'generalMetaData'
export const BOT_NAME = 'botName'
export const SESSION_ID = 'sessionId'
export const SET_NETWORK_USAGE = 'SET_NETWORK_USAGE'
export const SET_IS_SHOWING_NETWORK_STATS = 'SET_IS_SHOWING_NETWORK_STATS'
export const NETWORK_USAGE = 'networkUsage'
export const IS_SHOWING_NETWORK_STATS = 'isShowingNetworkStats'
export const VNSTAT_URL = `${KAYTEK_LOCAL_SERVICE_BASE_URL}/os/vnstat/monthly?iface=wlp5s0`
export const INITIATOR_STT = 'initiatorStt'
export const INITIATOR_AUPRED = 'initiatorAupred'
export const INITIATOR_HUMAN = 'initiatorHuman'
export const LAST_INITIATOR = 'lastInitiator'
export const USER_PROMPT_PREFIX = ''
export const USER_PROMPT_SUFFIX = '\n'
export const ENABLE_IMAGE_ON_STT_AND_MANUAL = true
